import { IService } from "../api/IService";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("WorldAssignment.Service");
//var XMLHttpRequest = require('xmlhttprequest').XMLHttpRequest;

export class Service implements IService {

    private request: XMLHttpRequest;
    private url: string;
    private resolve: (value?: string) => void;
    private reject: (reason?: any) => void;

    constructor(url: string) {
        this.url = url;
        this.request = new XMLHttpRequest();
        this.request.open("GET", this.url, true); /*open("GET", this.url += ((/\?/).test(url) ? "&" : "?") + (new Date()).getTime(), true);*/
        this.request.onload = this.onload;
        this.request.onerror = this.onerror;
    }

    public load(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            logger.debug("Service.load: ", this.url);
            if (this.request) {
                this.resolve = resolve;
                this.reject = reject;
                this.request.send();
                logger.debug("Service.load: request.send");
            } else {
                reject(false);
            }
        });
    }

    public dispose(): void {
        if (this.request) {
            this.request.onload = null;
            this.request.onerror = null;
            this.request = null;
        }
        this.resolve = null;
        this.reject = null;
    }

    private onload = () => {
        if (this.request.status >= 200 && this.request.status < 300 && this.request.responseText) {
            logger.debug("SERVICE RESULT - SUCCESS");
            this.resolve(this.request.responseText);
        } else {
            logger.debug("SERVICE RESULT - FAILURE:", this.request.status, this.request.responseText);
            this.reject(false);
        }
    }

    private onerror = (event: ErrorEvent) => {
        logger.debug("SERVICE RESULT - ERROR:", event);
        this.reject(event);
    }
}
